<template>
  <div class="template">
    <div class="search">
      <div class="search-center">
        <div class="search-item">
          <Input clearable
                 v-model="search.userId"
                 placeholder="用户id"
                 style="width: 150px;"
          ></Input>
        </div>
        <div class="search-item">
          <Input clearable
                 v-model="search.nickname"
                 placeholder="昵称"
                 style="width: 150px;"
          ></Input>
        </div>
        <!-- 日期范围选择 -->
        <div class="search-item">
          <DatePicker
              type="daterange"
              v-model="search.dateRange"
              placeholder="选择日期范围"
              style="width: 200px"
          ></DatePicker>
        </div>

        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="primary"
            icon="ios-search"
            @click="searchFn"
        >查询
        </Button>
        <Button
            style="width: 80px;margin-right: 10px;margin-bottom:5px"
            type="default"
            icon="ios-arrow-back"
            @click="back"
        >返回
        </Button>

      </div>
    </div>
    <div class="table">
      <Table
          :columns="diyData.columns"
          :data="apiData.tableList"
      >
        <template slot="footer">
          <Page
              :total="apiData.total"
              show-total
              :page-size="search.pageSize"
              :current="search.pageNo"
              @on-change="pageChange"
              @on-page-size-change="pageSizeChange"
              class-name="footer-page"
              show-elevator
              show-sizer
              placement="top"
          ></Page>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import {apiStatistics} from '@/api/withdrawal-manage.js'
import {getDateTime} from '@/libs/util'

export default {
  name: 'cashout-statistics',
  data() {
    return {
      showModal: false,
      ensureForm: {
        cashOutNo: '',
        result: 'success', // 默认选中"标记成功"
        comments: '' // 备注内容},
      },
      query: {},
      totalCashOut: 0,
      search: {
        cashOutNo: '',
        userId: '',
        nickname: '',
        trancId: '',
        realname: '',
        phone: '',
        status: '',
        pageNo: 1,
        pageSize: 10,
        dateRange: [] // 日期范围
      },
      diyDom: {
        showModal: false
      },
      diyData: {
        columns: [
          {
            title: '用户ID',
            width: '150px',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.search.userId = params.row.userId,
                          this.searchFn()
                    }
                  }
                }, params.row.userId)
              ])
            }
          },
          {
            title: '昵称',
            width: '200px',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  on: {
                    click: () => {
                      this.search.nickname = params.row.nickname,
                          this.searchFn()
                    }
                  }
                }, params.row.nickname)
              ])
            }
          },
          {
            title: '提现金额',
            width: '200px',
            key: 'amount'
          },
        ]
      },
      apiData: {
        total: 0,
        tableList: []
      }
    }
  },
  methods: {
    // 分页
    pageChange(e) {
      this.search.pageNo = e
      this.getTableList()
    },
    pageSizeChange(e) {
      this.search.pageSize = e
      this.search.pageNo = 1
      this.getTableList()
    },
    // 搜索
    searchFn() {
      this.search.pageNo = 1
      this.getTableList()
    },
    back() {
      this.$router.go(-1);
    },
    getTableList() {
      this.$store.commit('setSpinShow', true)
      var opt = {...this.search, ...this.query}
      // 处理日期范围参数
      if (this.search.dateRange && this.search.dateRange.length === 2) {
        opt.dateStart = getDateTime(this.search.dateRange[0])
        opt.dateEnd = getDateTime(this.search.dateRange[1])
      }
      delete opt.dateRange
      apiStatistics(opt).then((res) => {
        const {
          list,
          totalCount,
        } = res.data

        this.apiData.tableList = list
        this.apiData.total = totalCount
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
  },
  mounted() {
    this.query = this.$route.query
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
.template {
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
}

/* 提现总金额样式 */
.total-amount {
  margin: 10px 0 0;
  padding: 3px 15px;
  background-color: #f0f8ff;
  border: 1px solid #d0e9ff;
  border-radius: 4px;
  display: inline-block;

  .label {
    font-weight: bold;
    color: #333;
    font-size: 14px;
  }

  .amount {
    font-size: 18px;
    font-weight: bold;
    color: #ff6600;
    margin: 0 5px;
  }

  .unit {
    color: #666;
    font-size: 14px;
  }
}

.button-border {
  margin-right: 10px;
}
</style>
